var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.86H17.74C16.94 18.86 16.18 19.17 15.62 19.73L13.91 21.42C13.13 22.19 11.86 22.19 11.08 21.42L9.37 19.73C8.81 19.17 8.04 18.86 7.25 18.86H6.5C4.84 18.86 3.5 17.53 3.5 15.89V4.97C3.5 3.33 4.84 2 6.5 2H18.5C20.16 2 21.5 3.33 21.5 4.97V15.88C21.5 17.52 20.16 18.86 18.5 18.86Z",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5699 8.9498C12.5299 8.9498 12.4699 8.9498 12.4199 8.9498C11.3699 8.9098 10.5399 8.0598 10.5399 6.9998C10.5399 5.9198 11.4099 5.0498 12.4899 5.0498C13.5699 5.0498 14.4399 5.9298 14.4399 6.9998C14.4499 8.0598 13.6199 8.9198 12.5699 8.9498Z",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74994 11.96C8.41994 12.85 8.41994 14.3 9.74994 15.19C11.2599 16.2 13.7399 16.2 15.2499 15.19C16.5799 14.3 16.5799 12.85 15.2499 11.96C13.7399 10.96 11.2699 10.96 9.74994 11.96Z",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.fc3552d4334e0224e473e06e5bc78a61.svg";
export { ForwardRef as ReactComponent };